import PropTypes from "prop-types";
import { Row, Select, Spin } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import API from "../services/api-request";

const SelectPallet = ({
  value,
  onChange,
  allowUsed = true,
  usedOnly = false,
}) => {
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPallet = useCallback(async () => {
    setLoading(true);
    try {
      let queryParam = "";
      if (usedOnly) {
        queryParam = "weightGreaterThanZero=true";
      } else if (!allowUsed) {
        queryParam = "emptyOrZeroWeightStock=true";
      }
      const res = await API.Get(`pallet?${queryParam}`);
      setListData(res?.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [allowUsed, usedOnly]);

  useEffect(() => {
    getPallet();
  }, [getPallet]);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={listData.length < 1 ? "No Data" : value || null}
      optionFilterProp="label"
      placeholder="Pilih Pallet"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.name,
        value: e.id,
        type: e.type,
      }))}
    />
  );
};


SelectPallet.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowUsed: PropTypes.bool,
  usedOnly: PropTypes.any,
};

export default SelectPallet;
